const en_us = {
    values: {
    }
}

export default en_us